import { inject, injectable } from 'inversify'
import 'reflect-metadata'
import { TYPES } from '../../../../common/domain/types'

import type { ISearchConfigRepository } from '../domain/ISearchConfigRepository';
import { IServiceSearchConfig } from './IServiceSearchConfig';
import { IampSearchConfig } from '../domain/iampSearchConfig';



@injectable()
export class ServiceSearchConfig implements IServiceSearchConfig {
  private readonly repo: ISearchConfigRepository

  public constructor (@inject(TYPES.SEARCH_USR_REPOSITORY) _repo: ISearchConfigRepository) {
    this.repo = _repo
  }
   

  async update (data: IampSearchConfig): (Promise<IampSearchConfig>) {
    return await this.repo.update(data);
  }

  async add (data: IampSearchConfig): (Promise<IampSearchConfig>) {
    return await this.repo.add(data);
  }

  async getByAllByUserId (userId: number, applicationId: number, applicationVersion: number, componentId: number) :Promise<IampSearchConfig[]> {
    return await this.repo.getByAllByUserId(userId,applicationId,applicationVersion,componentId)
  }

  async delete (userId: number, applicationId: number, applicationVersion: number, componentId: number, name: string):Promise<boolean> {
    return await this.repo.delete(userId, applicationId, applicationVersion, componentId, name)
  }
}
